import Events from '@/domain/events/index';
import { getEvents } from '@/infra/events/eventRepository';

export async function getEventsAll(): Promise<{ items: Events[] }> {
  try {
    const res = await getEvents();
    const events = res?.events?.map((e: ResolvedEventData) => new Events(e));
    return { items: events };
  } catch (error: any) {
    if (error.message === 'ServerError') {
      throw error;
    }
    throw error;
  }
}

export default getEventsAll;

export type ResolvedEventData = Events;
